<template>
  <GmapCustomMarker class="point-marker" :marker="marker">
    <div class="point-marker__shadow" />
    <img
      alt="point-marker"
      src="@/assets/images/point/marker-no-shadow.svg"
      class="point-marker__marker"
      :class="{ dragging: isDragging }"
    />

    <div class="point-marker__container" :class="{ dragging: isDragging }">
      <div class="__icon" />
    </div>
  </GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
  components: {
    GmapCustomMarker,
  },
  props: {
    marker: {
      type: Object,
      default: () => {},
    },
    isDragging: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.point-marker {
  position: relative;
  text-align: center;
  cursor: pointer;

  img {
    width: 100%;
    z-index: 1000;
  }

  &__shadow {
    position: absolute;
    bottom: -2px;
    left: 17.2px;
    z-index: 1;
    width: 5px;
    height: 3px;
    background-color: #0d449114;
    border-radius: 50%;
  }

  &__container {
    width: 34px;
    height: 34px;
    background-color: $mep-secondary;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    display: flex;
    justify-content: center;
    align-items: center;

    .__icon {
      background-color: $white;
      height: 16px;
      width: 16px;
      border-radius: 50%;
    }
  }
}

.dragging {
  animation: bounce 2s ease infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-8px);
  }
}
</style>
